/* ============
 * Send reminder
 * ============
 *
 * Send reminder
 */

import Vue from 'vue';

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`bills/payment_reminder_preview/${id}`)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.response);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/sendReminderPreview.js